document.addEventListener('DOMContentLoaded',()=>{const toggle=document.querySelector('.menu-toggle');const nav=document.querySelector('#primary-nav');toggle?.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open)});document.querySelectorAll('[data-variant-select]').forEach(select=>select.addEventListener('change',()=>{const price=select.closest('.product-info').querySelector('[data-product-price]');const option=select.selectedOptions[0];if(price&&option)price.textContent=option.dataset.price||''}));});
document.querySelectorAll('.site-motion-bg video').forEach(video=>{video.muted=true;video.setAttribute('playsinline','');video.play().catch(()=>{});});

document.querySelectorAll('.sc-game-frame').forEach(frame=>{
  let mountedDocument;
  let resizeObserver;
  let screenObserver;
  let scheduleResize=()=>{};
  const mount=()=>{
    try{
      const doc=frame.contentDocument;
      if(!doc?.body||doc.readyState!=='complete'||doc===mountedDocument)return;
      resizeObserver?.disconnect();
      screenObserver?.disconnect();
      mountedDocument=doc;
      const body=doc.body;
      const style=doc.createElement('style');
      style.textContent=`
        html{overflow-y:hidden}
        body{min-height:0!important}
        #game,#touch{touch-action:pan-y pinch-zoom}
        #touch button{touch-action:none}
        .sc-mobile-landscape header{min-height:40px;padding:5px 14px}
        .sc-mobile-landscape .brand{font-size:16px}
        .sc-mobile-landscape .brand img{width:26px;height:26px}
        .sc-mobile-landscape .brand small{display:none}
        .sc-mobile-landscape nav button{min-height:28px;padding:5px 10px;font-size:10px}
        .sc-mobile-landscape #gamePage{padding:4px 12px}
        .sc-mobile-landscape .hud{margin-bottom:4px;gap:20px}
        .sc-mobile-landscape .hud strong{font-size:17px}
        .sc-mobile-landscape .hud small{font-size:8px;margin-bottom:3px}
        .sc-mobile-landscape #arena{width:min(100%,calc((var(--sc-host-height) - 210px - var(--page-top) - var(--page-bottom))*1.7778));min-width:0;margin:auto;aspect-ratio:16/9}
        .sc-mobile-landscape #touch{max-width:640px;margin:auto;padding:4px 14px 6px}
        .sc-mobile-landscape .controlBrand,.sc-mobile-landscape .directions small{display:none}
        .sc-mobile-landscape .controlDeck{height:48px}
        .sc-mobile-landscape .directions button{width:48px;height:40px;min-height:40px;font-size:23px}
        .sc-mobile-landscape .actionButtons button{width:44px;height:44px;min-height:44px;font-size:10px}
        .sc-mobile-landscape .utilityButtons{margin-top:3px}
        .sc-mobile-landscape .utilityButtons button{min-height:26px;padding:4px 12px}
        .sc-mobile-landscape footer{padding:4px 0;font-size:9px}
        .sc-mobile-landscape footer button{min-height:26px;padding:4px 8px;font-size:9px}
      `;
      doc.head.appendChild(style);
      let resizePending=false;
      const resize=()=>{
        body.style.setProperty('--sc-host-height',window.innerHeight+'px');
        // The iframe height is content-sized; use the phone's orientation.
        body.classList.toggle('sc-mobile-landscape',window.innerWidth>window.innerHeight&&window.innerHeight<=600);
        // Measure content, rather than the iframe viewport, so it can shrink.
        const height=Math.ceil(body.getBoundingClientRect().height)+2;
        if(height>2&&frame.style.height!==height+'px')frame.style.height=height+'px';
      };
      scheduleResize=()=>{
        if(resizePending)return;
        resizePending=true;
        requestAnimationFrame(()=>{resizePending=false;resize()});
      };
      resizeObserver=new ResizeObserver(scheduleResize);
      resizeObserver.observe(body);
      const gamePage=doc.getElementById('gamePage');
      if(gamePage){
        const alignScreen=()=>requestAnimationFrame(()=>requestAnimationFrame(()=>{
          resize();
          const header=document.querySelector('.site-header');
          frame.style.scrollMarginTop=Math.ceil(header?.getBoundingClientRect().height||0)+'px';
          frame.scrollIntoView({block:'start',behavior:'instant'});
        }));
        let playing=!gamePage.classList.contains('hidden');
        screenObserver=new MutationObserver(()=>{
          const nextPlaying=!gamePage.classList.contains('hidden');
          if(nextPlaying===playing)return;
          playing=nextPlaying;
          resize();
          alignScreen();
        });
        screenObserver.observe(gamePage,{attributes:true,attributeFilter:['class']});
        doc.defaultView.addEventListener('hashchange',()=>{
          if(['#play','#characters'].includes(doc.defaultView.location.hash))alignScreen();
        });
      }
      resize();
    }catch(e){frame.style.height='1100px'}
  };
  frame.addEventListener('load',mount);
  // Keep the listener bound to the latest document if the iframe reloads.
  window.addEventListener('orientationchange',()=>scheduleResize());
  window.addEventListener('resize',()=>scheduleResize());
  mount();
});
